function getSite(url: string) {
  return new URL(url).hostname.split('.').slice(-2).join('.');
}

export function isSameSite(urlA: string, urlB: string) {
  return getSite(urlA) === getSite(urlB);
}
